import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on, StoreModule } from '@ngrx/store';
import { CommunityItem } from 'src/app/models/community-item';
import * as CommunityListActions from './community-list.actions';

export const communityListFeatureKey = 'communityList';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CommunityListState
    extends EntityState<{ id: string; list: CommunityItem[] }> {}

export const adapter: EntityAdapter<{
    id: string;
    list: CommunityItem[];
}> = createEntityAdapter<{ id: string; list: CommunityItem[] }>({
    selectId: (container: { id: string; list: CommunityItem[] }) =>
        container.id,
});

export const initialState: CommunityListState = adapter.getInitialState();

export const communityListReducer = createReducer(
    initialState,
    on(CommunityListActions.SetCommunityList, (state, props) => {
        return adapter.upsertOne(props, state);
    }),
    on(CommunityListActions.AppendCommunityList, (state, props) => {
        const currList = state.entities[props.id]?.list;
        if (currList) {
            props.list = [...currList, ...props.list];
        }
        return adapter.upsertOne(props, state);
    }),
    on(CommunityListActions.UpdateItemInCommunityLists, (state, props) => {
        const entries: {
            id: string;
            list: CommunityItem[];
        }[] = [];
        for (const [id, entry] of Object.entries(state.entities)) {
            if (entry?.list.some((x) => x.id === props.item.id)) {
                entries.push({
                    id,
                    list: entry.list.map((x) =>
                        x.id !== props.item.id ? x : props.item
                    ),
                });
            }
        }
        return adapter.upsertMany(entries, state);
    }),
    on(CommunityListActions.RemoveItemFromCommunityLists, (state, props) => {
        const entries: {
            id: string;
            list: CommunityItem[];
        }[] = [];
        for (const [id, entry] of Object.entries(state.entities)) {
            if (entry?.list.some((x) => x.id === props.id)) {
                entries.push({
                    id,
                    list: entry.list.filter((x) => x.id !== props.id),
                });
            }
        }
        return adapter.upsertMany(entries, state);
    })
);

export const communityListStoreModule = StoreModule.forFeature(
    communityListFeatureKey,
    communityListReducer
);
